import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import {
    BlobTypeStoreReadSettingsAdapter,
    blobTypeStoreReadSettingsAdapts
} from './blob-type-store-read-settings.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { LakehouseReadSettings } from 'app/model/pipeline/copysource/store-read-settings/lakehouse-read-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(LakehouseReadSettings),
    asynchronous: true,
    adapts: {
        deleteFilesAfterCompletion: '*',
        ...blobTypeStoreReadSettingsAdapts
    }
})
export class LakehouseStoreReadSettingsAdapter extends BlobTypeStoreReadSettingsAdapter<
    LakehouseReadSettings,
    Model.StoreReadSettings
> {
    protected override async _toModel(
        resource: Model.StoreReadSettings,
        copySource: CopySource
    ): Promise<LakehouseReadSettings> {
        const model = await super._toModel(resource, copySource);
        ValueAdapter.toModel(
            model,
            LakehouseReadSettings.DELETE_FILE_AFTER_COMPLETION,
            resource.deleteFilesAfterCompletion
        );
        return model;
    }

    protected override async _toResource(settings: LakehouseReadSettings): Promise<Model.StoreReadSettings> {
        const resource = await super._toResource(settings);
        if (resource != null) {
            resource.deleteFilesAfterCompletion = ValueAdapter.toResource(
                settings,
                LakehouseReadSettings.DELETE_FILE_AFTER_COMPLETION
            );
        }
        return resource;
    }
}
